<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Pending Orders</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        
        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :headers="headers" :items="orders" :search="search">
              <template v-slot:item.DocTotal="{ item }">
                <span>{{ item.DocTotal.toLocaleString() }}</span>
              </template>
              <template v-slot:item.status="{ item }">
                <span style="color: blue">Received</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn color="accent" text :to="`/customer-order/${item.id}`">
                  <v-icon left>mdi-eye</v-icon> More Details
                </v-btn>
              </template>
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Doc No.", value: "DocNum" },
      { text: "Customer", value: "ocrd.Name" },
      { text: "Total Order Amount", value: "DocTotal" },
      { text: "Date", value: "DocDate" },
      { text: "Status", value: "status" },
      { text: "View Details", value: "action" },
    ],
    orders: [],
  }),
  methods: {
    getOrders() {
      let data = {};
      data.StartDate = this.date;
      data.combinedReport = "N";
      const self = this;
      const url = `/documents/14`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.orders = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getOrders();
  },
};
</script>